import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["theme", "loading", "size", "children", "beforeIcon", "afterIcon", "fullWidth"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { useUiKitThemeContext } from '../../../internal/context';
import { getTheme } from '../../themes';
import { Spinner } from '../../../loader';
import * as customStyles from '../../styles/button.module.css';
import * as styles from '../../styles/shared.module.css';

/**
 * Компоненты кнопки. <br />
 * Компонет имеет настройки тем, размеров, умеет отображать прелоадер, иконки и текст. Кроме того кнопки меняют свое отображение в завсимости от пользовательских действий.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ButtonComponent = /*#__PURE__*/React.forwardRef(function Button(_ref, ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'fill_primary' : _ref$theme,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'M' : _ref$size,
    children = _ref.children,
    beforeIcon = _ref.beforeIcon,
    afterIcon = _ref.afterIcon,
    fullWidth = _ref.fullWidth,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useUiKitThemeContext = useUiKitThemeContext(),
    globalTheme = _useUiKitThemeContext.theme;
  var themeClasses = getTheme(theme);
  var buttonClasses = clsx(styles['button'], customStyles['button'], styles[size], themeClasses['button'], themeClasses[globalTheme], _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, customStyles['loading'], loading), styles['full-width'], fullWidth), styles['button--before-icon'], beforeIcon), styles['button--after-icon'], afterIcon));
  return /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread({
    className: buttonClasses
  }, rest), {}, {
    ref: ref,
    children: [loading && /*#__PURE__*/_jsx("span", {
      className: clsx(styles['spinner'], customStyles['spinner'], themeClasses['spinner']),
      children: /*#__PURE__*/_jsx(Spinner, {
        color: "current_color",
        size: 16
      })
    }), beforeIcon, children && /*#__PURE__*/_jsx("span", {
      className: styles['text'],
      children: children
    }), afterIcon]
  }));
});
export var Button = /*#__PURE__*/React.memo(ButtonComponent);